import { z } from "zod";
import { routeSchema } from "./routes";
import { unenrichedVisitSchema } from "./visits.unenriched";

// A route as the logistics host sends it, with each visit's patient still an
// id. See activities.unenriched.ts for why the two are joined in the client.
export const unenrichedRouteSchema = routeSchema
  .omit({ visits: true })
  .extend({ visits: z.array(unenrichedVisitSchema) });
export type IUnenrichedRoute = z.infer<typeof unenrichedRouteSchema>;

export const unenrichedRoutesSchema = z.array(unenrichedRouteSchema);
